import { cn } from "@/shared/lib/utils";
import type { SetupPlayer } from "../setup.types";
import { PlayerLabel } from "./PlayerLabel";

// Compact player card: role icon on the left, class-colored name.
export function SetupPlayerRow({
  player,
  className,
}: {
  player: SetupPlayer;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-md border border-border bg-card px-2.5 py-1.5 text-sm hover:bg-muted/40",
        className,
      )}
    >
      <PlayerLabel
        player={player}
        nameClassName="min-w-0 truncate"
        badgeClassName="shrink-0 px-1.5 py-0.5 text-xs"
      />
    </div>
  );
}
